import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./Home";
import Franchise from "./Franchise";
import ScrollToTop from "./ScrollToTop";
import "./styles/style.css";
import CSLayout from "./Layout";

export default function App() {
  const location = useLocation();

  useEffect(() => {
    let frontEnd = document.createElement("script");
    frontEnd.src = "/assets/js/_1_back-to-top.js"; // 👈 make sure to use the correct path
    frontEnd.id = "_1_back-to-top-js";
    document.body.appendChild(frontEnd);

    return () => {
      document.getElementById("_1_back-to-top-js").remove();
    };
  }, []);

  useEffect(() => {
    const isPromotionsPath = window.location.pathname === "/promotions";
    const anchor = isPromotionsPath || location.pathname === "/promotions"
      ? "promotions"
      : location.hash && location.hash.substr(1);

    if (!anchor) return;

    const scrollToAnchor = () => {
      const el = document.getElementById(anchor);
      if (!el) return;

      const header = document.querySelector(".f-header");
      const headerOffset = header ? header.getBoundingClientRect().height + 16 : 0;
      const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({ top, behavior: "smooth" });
    };

    const firstTimer = window.setTimeout(scrollToAnchor, 0);
    const secondTimer = window.setTimeout(scrollToAnchor, 350);

    return () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(secondTimer);
    };
  }, [location.hash, location.pathname]);

  return (
    <div className="App">
      {/* <div>{i18n.language}</div> */}
      <Routes>
        <Route element={<CSLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/promotions" element={<Home />} />
          <Route path="/franchise" element={<Franchise />} />
        </Route>

      </Routes>

      <a className="back-to-top js-back-to-top" href="#0" data-offset={100} data-duration={300}>
        <svg className="icon" viewBox="0 0 20 20">
          <polyline
            points="2 13 10 5 18 13"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />
        </svg>
      </a>

      <ScrollToTop />
    </div>
  );
}
